module.exports = __webpack_public_path__ + "img/17.981d7d7a.jpg";